
















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { DatePickerOptions } from "element-ui/types/date-picker";
 
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class OnekeyBlock extends Vue {
    file: any = {};

    changePutFile(e: any) {
        if (e.target.files[0]) {
            this.file = e.target.files[0];
        }
    }
    // 保存  取消
    save() {
        if (this.file.name) {
            let data = new FormData();
            data.append("file", this.file);
            data.append("accountBookId", this.$store.state.accountBook.id);
            data.append("fileName", this.file.name);
            this.$emit("startUpload")
            let onkeyPut: any = document.querySelector(".oneKey-put");
            Vue.axios
                .post(`upload/initbalance`, data)
                .then(res => {
                    this.file = {}
                    onkeyPut.value = ""
                    this.$emit("close", true, res)
                })
                .catch(res => {
                    this.file = {}
                    onkeyPut.value = ""
                    this.$emit("close", false)
                });
        }
    }
    close() {
        this.$emit("close",false)
    }
}
